export default __webpack_public_path__ + "static/media/faciey.7c9411b2.png";